// extracted by mini-css-extract-plugin
export var accordion = "FAQsV2-module--accordion--a13c2";
export var custom = "FAQsV2-module--custom--d71ae";